// 替换所有
String.prototype.replaceAll = function(s1, s2) {
  return this.replace(new RegExp(s1, "gm"), s2);
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js